import { plotLayout } from '../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { Grid } from '../../core/components/grid/Grid.js';
import { useXScales } from '../hooks/useXScale.js';
import { useYScales } from '../hooks/useYScales.js';

export const TimeseriesChartGridLayout = () => {
  const { width, height } = useGridPlotSize();
  const { currentScale: xScale } = useXScales();
  const { left, right } = useYScales();
  const axisScale = left || right;

  if (!axisScale) {
    return null;
  }

  return (
    <svg className={plotLayout}>
      <Grid
        xScale={xScale}
        yScale={axisScale.scale}
        height={height}
        width={width}
      />
    </svg>
  );
};

TimeseriesChartGridLayout['displayName'] = 'TimeseriesChartGridLayout';
